import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { ProductRequestStatus } from '../../../enum/ProductRequestStatus';
import { RoleAccess } from '../../../models/role-access.model';
import { UserProfile } from '../../../models/user-profile.model';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from '../../../providers/user-data';
import { AlertController, ModalController, NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../../service/util.service';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { environment } from '../../../../environments/environment';
import { ProductRequestService } from '../../product-request/product-request.service';
import { HomeService } from '../../home/home.service';
import { MyService } from '../../../service/my.service';
import { ProductRequestBundle } from '../../../models/product-request-bundle.model';
import { FindProductComponent } from '../../../component/find-product/find-product.component';

class Product {
  public id: string;
  public product_name: string;
}
@Component({
  selector: 'app-po-auto-create',
  templateUrl: './po-auto-create.page.html',
  styleUrls: ['./po-auto-create.page.scss'],
})

export class PoAutoCreatePage implements OnInit {

  @ViewChildren('rowRef') rowRefs!: QueryList<ElementRef>;
  constructor(
    private fb:FormBuilder,
    private storage: Storage,
    private router: Router,
    private userDataProvider: UserData,
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private utilService: UtilService,
    private activeRoute:ActivatedRoute,
    private requestService: ProductRequestService,
    private homeService: HomeService,
    private myService:MyService,
    private alertController:AlertController,
    private modalController:ModalController
  ) { }

  token: any;
  userProfile: UserProfile = new UserProfile();
  productRequestId: any;
  productList: Product[];
  counterList: any[] = [];
  warehouseList: any[] = [];
  productRequestData: any;
  productRequestDetailData: any[] = [];
  approvalHistoryData: any[] = [];
  createdBy: any;
  createdAt: any;
  updatedBy: any;
  updatedAt: any;
  unitType: any[] = ['PIECES'];
  statusRequest: any = 0;
  statusName: any;
  productRequestDetailList: any[] = [];
  dataPoAuto:any[]=[];

  formProductRequestDetail: FormGroup;

  requestStatus = ProductRequestStatus;
  requestStatusList = Object.keys(ProductRequestStatus).filter(
    requestStatus => typeof this.requestStatus[requestStatus] === 'number'
  );

  userAccess: any[] = [];
  roleAccess = new RoleAccess();
  roleName: any;

  timezone: any[] = ['Asia/Jakarta', 'Asia/Makassar', 'Asia/Jayapura'];
  showProposal:boolean=false;
  counterId:any='';
  warehouseId:any='';
  listMonth:any[]=[];
  
  DECIMAL_SEPARATOR:any=".";
  GROUP_SEPARATOR:any=",";
  turn_over_stock:number=15;
  turn_over_order:number=18;
  ngOnInit() {
    this.buildFormPOAuto();
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.userAccess = access;
        this.roleName = this.userProfile.role_detail ? this.userProfile.role_detail.role_name : null;
        this.roleAccess = this.userDataProvider.checkAccess(this.router.url, this.userAccess, this.userProfile);
        if(!this.roleAccess || this.roleAccess.create!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.getListCounters();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  getListCounters(){
    let options = { 
      "token": this.token,
      "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list
    };
    this.requestService.getRequestforCreate(options).subscribe((response) => {
      this.utilService.loadingDismiss();
      if (response.status.code === 200) {
        this.counterList = response.results.counter_data;
        this.warehouseList = response.results.warehouse_data;
        this.buildFormPOAuto();
        this.getDataPoAuto();
      }
    }, () => {
      this.utilService.loadingDismiss();
      this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
    });
  }
  buildFormPOAuto(){
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.productRequestId = AES.decrypt(snapshot.i, myKey).toString(utf8);
      this.productRequestId = this.productRequestId.replaceAll('"','');
      let hasil = this.productRequestId.split('#');
      this.counterId = parseInt(hasil[1]);
      this.warehouseId = parseInt(hasil[2]);
      let newDate = new Date();
      let convertDate = this.utilService.convertDate(newDate);
      let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      this.formProductRequestDetail = this.fb.group({
        productRequestId: [this.productRequestData ? this.productRequestData[0].id : null],
        docDate: [this.productRequestData ? this.productRequestData[0].doc_date : todayDate],
        needDate: [this.productRequestData ? this.productRequestData[0].need_date : todayDate],
        counterId: [this.counterId],
        warehouseId: [this.warehouseId],
        description: [this.productRequestData ? this.productRequestData[0].desc : null],
        proposalNumber: [this.productRequestData ? this.productRequestData[0].proposal_number : null],
        proposalPeriod: [''],
        proposalDesc: [this.productRequestData ? this.productRequestData[0].proposal_desc : null],
        status: [this.statusName ? this.statusName : this.requestStatusList[0]],
        detail: this.fb.array([])
      });
    })
  }
  
  getDataPoAuto() {
    const bulanIndonesia = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
    let newDate = new Date();
    let threeMonthsAgo = new Date(newDate);
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    let tahun = threeMonthsAgo.getFullYear();
    let start_date = tahun+'-'+(threeMonthsAgo.getMonth() + 1).toString().padStart(2, '0')+'-01';
    let lastDayOfLastMonth = new Date(newDate.getFullYear(), newDate.getMonth(), 0);
    let year = lastDayOfLastMonth.getFullYear();
    let month = (lastDayOfLastMonth.getMonth() + 1).toString().padStart(2, '0'); // tambahkan 0 di depan jika < 10
    let day = lastDayOfLastMonth.getDate().toString().padStart(2, '0');
    let formattedDate = `${year}-${month}-${day}`;
    const bulan = this.getMonthsInRange(start_date, formattedDate);
    let currentMonth = (newDate.getMonth() + 1).toString().padStart(2, '0');
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let convertDate = this.utilService.convertDate(newDate);
      let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      let options = {
        "token": this.token,
        "year": convertDate.years,
        "month": convertDate.months,
        "today": todayDate,
        "start_date": start_date,
        "end_date": formattedDate,
        "cashier_id": this.userProfile.cashier_id ? this.userProfile.cashier_id : 0,
        "counter_id": this.counterId
      };
      this.homeService.getDashboardPoAuto(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        let salesData: any[] = response.results.data_sales;
        let stockData: any[] = response.results.data_stock;
        let jumlah_hari : any = response.results.jumlah_hari; 
        let settingPO = response.results.setting_po;
        for(let y = 0; y < bulan.length; y++) {
          let bulannam = bulanIndonesia[bulan[y]-1];
          this.listMonth.push(bulannam);
        }
        if(response.results.warehouse){
          this.warehouseId =response.results.warehouse.id;
        }
        this.dataPoAuto =[];
        if(stockData.length > 0) {
          for(let x = 0; x < stockData.length; x++) {
            let pcode = stockData[x].product_id;
            let getStock = stockData.find(z => z.product_id === pcode);
            let stock =0;
            if(getStock){
              stock = getStock[`end_${currentMonth}`];
            }
            let productName = stockData[x].product_name;
            let getSales = [];
            let totalSales = 0;
            let asq =0;
            for(let y = 0; y < bulan.length; y++) {
              let sales1 = salesData.find(z => z.product_id === pcode && z.month==bulan[y]);
              let total_qty =0;
              if(sales1){
                total_qty = parseInt(sales1.total_qty);
              }
              getSales.push(total_qty);
              totalSales+=total_qty;
              asq = totalSales/jumlah_hari;
            }
            this.turn_over_stock = settingPO.turn_over_stock ? parseInt(settingPO.turn_over_stock) : this.turn_over_stock;
            this.turn_over_order = settingPO.turn_over_order ? parseInt(settingPO.turn_over_order) : this.turn_over_order;
            let data = {
              pcode: pcode,
              name: productName,
              getSales: getSales,
              totalSales: totalSales,
              jumlah_hari:jumlah_hari,
              stock:stock,
              asq : asq,
              turnover_stock : stock/asq,
              qty_po:stock/asq<=this.turn_over_stock ?this.hitungNilai(asq) :''
            }
            if(stock/asq<=this.turn_over_stock){
              this.dataPoAuto.push(data);
              this.dataPoAuto.sort((a, b) => b.qty_po - a.qty_po);
            }
          }
          if(this.dataPoAuto.length>0){
            for (let pp=0;pp<this.dataPoAuto.length;pp++){
              let qty = this.myService.separator(this.dataPoAuto[pp].qty_po);
              qty = String(qty).replace(/[^0-9,]/g, '');
              const detail = this.fb.group({
                pcode: [this.dataPoAuto[pp].pcode, Validators.required],
                product_name: [this.dataPoAuto[pp].name, Validators.required],
                qty: [qty, Validators.required],
                isNew: [false]
              });
              this.getDetailArray.push(detail);
            }
          }
        }
        
       this.getAllProduct();

      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  

  format(valString) {
    if (!valString) {
        return '';
    }
    let val = valString.toString();
    const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
    return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
};

unFormat(val) {
    if (!val) {
      return '';
    }
    val = val.replace(/^0+/, '');
    if (this.GROUP_SEPARATOR === ',') {
      return val.replace(/,/g, '');
    } else {
      return val.replace(/\./g, '');
    }
};
numberOnlyValidation(event: any) {
  const pattern = /[0-9.,]/;
  let inputChar = String.fromCharCode(event.charCode);
  if (!pattern.test(inputChar)) {
    // invalid character, prevent input
    event.preventDefault();
  }
  
}
  get getDetailArray() {
    return (<FormArray>this.formProductRequestDetail.get('detail'));
  }
  onChangePrice(index:any,columnname:any){
    let arrform=<FormArray>this.formProductRequestDetail.controls['detail'];    
    let cur= arrform.controls[index].value[columnname];
    let curWithSeparator='0';
    if(cur!='0' && cur!='' && cur!=null){
      curWithSeparator = this.myService.separator(cur);
      curWithSeparator = String(curWithSeparator).replace(/[^0-9,]/g, '');
    }
    arrform.controls[index].patchValue({[columnname]:curWithSeparator});
  }
  hitungNilai(n22: number): number | string {
    const hasil = Math.ceil((this.turn_over_order * n22) / 3) * 3;
    if(hasil>0){
      return hasil;
    }
    else{
      return '';
    }
  }

  getMonthsInRange(startDateStr: string, endDateStr: string): number[] {
      const start = new Date(startDateStr);
      const end = new Date(endDateStr);
      const result: number[] = [];

      // Normalisasi ke awal bulan
      start.setDate(1);
      end.setDate(1);

      while (start <= end) {
        const month = start.getMonth() + 1; // getMonth() 0–11 → +1 jadi 1–12
        result.push(month);

        // Tambah 1 bulan
        start.setMonth(start.getMonth() + 1);
      }
      return result;
  }
  back(){
    this.navCtrl.navigateForward(['/product-request']);
  }
  
  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.navCtrl.navigateForward(['/product-request']);;
          }
        }
      ]
    });
    await alert.present();
  }
  save(){
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const formProductRequest = this.formProductRequestDetail.value;
      let counterId = this.counterId;
      let warehouseId = this.warehouseId;
      let desc = formProductRequest.description;
      let docDateConvert = this.utilService.convertDate(formProductRequest.docDate);
      let needDateConvert = this.utilService.convertDate(formProductRequest.needDate);
      let documentDate = docDateConvert.years + '-' + docDateConvert.months + '-' + docDateConvert.dates;
      let dateOfNeed = needDateConvert.years + '-' + needDateConvert.months + '-' + needDateConvert.dates;
      let arrProduct: any = [];
      let arrQty: any = [];
      let arrUnitType: any = [];    
      const formProductRequestDetail = this.formProductRequestDetail.value;
      for(let x = 0; x <formProductRequestDetail.detail.length; x++) {
        if(formProductRequestDetail.detail[x].qty){
          arrUnitType[x] = 0;
          arrProduct[x] = formProductRequestDetail.detail[x].pcode;
          arrQty[x] = formProductRequestDetail.detail[x].qty ? this.myService.removeSeparator(formProductRequestDetail.detail[x].qty) : 0;
        }
      }
      const productRequestBundle = new ProductRequestBundle();
      productRequestBundle.productRequest.counter_id = counterId;
      productRequestBundle.productRequest.warehouse_id = warehouseId;
      productRequestBundle.productRequest.doc_date = documentDate;
      productRequestBundle.productRequest.need_date = dateOfNeed;
      productRequestBundle.productRequest.desc = desc;
      productRequestBundle.productRequest.status = '0';
      productRequestBundle.productRequest.created_by = this.userProfile.username;
      productRequestBundle.productRequest.po_auto = 'Y';
      productRequestBundle.productRequestDetail.product_id = arrProduct;
      productRequestBundle.productRequestDetail.qty = arrQty;
      productRequestBundle.productRequestDetail.unit = arrUnitType;
      this.requestService.addRequestBundle(productRequestBundle)
      .subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmInput();
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  addDetail() {
    const detail = this.fb.group({
      pcode: ['', Validators.required],
      product_name: ['', Validators.required],
      price: [0, Validators.required],
      qty: [0, Validators.required],
      isNew: [true]
    });
    this.getDetailArray.push(detail);
    setTimeout(() => {
      const rows = this.rowRefs.toArray();
      const lastRow = rows[rows.length - 1];
      lastRow.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }
  getAllProduct() {
    this.requestService.getProduct({ "token": this.token }).subscribe((response) => {
    if (response.status.code === 200) {
      this.productList = response.results;
    }})
  }
  async findProduct(index: any) {
    const modal = await this.modalController.create({
      component: FindProductComponent,
      componentProps: {
        'productList': this.productList
       },
      backdropDismiss: false
    });
  
    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      if(data) {
        let findProduct = this.productRequestDetailList.indexOf(data);
        if(findProduct === -1) {
          let arrform=<FormArray>this.formProductRequestDetail.controls['detail'];
          arrform.controls[index].patchValue({['product_name']: data.product_name});
          arrform.controls[index].patchValue({['pcode']: data.id});
        }
      }
    });
    return await modal.present();
  }
}